<!-- <style>
  .mat-tab-body-content {
    overflow: hidden !important;
  }
</style> -->
<div class="row">
  <div class="col-md-9"></div>
  <div class="col-md-3">
    <button mat-raised-button (click)="createPrePaidDialog('Add')">
      Create
    </button>
  </div>
</div>
<div class="table-responsive">
  <table mat-table [dataSource]="dataSource">
    <!-- Position Column -->
    <ng-container matColumnDef="action">
      <tr>
        <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">Action</th>
      </tr>
      <tr>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="'w-130'"
          style="width: 5%"
        >
          <button
            mat-icon-button
            color="primary"
            title="Edit Contact"
            (click)="createPrePaidDialog('Update', element)"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </tr>

      <tr></tr
    ></ng-container>
    <ng-container matColumnDef="ProviderName">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        ProviderName
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.ProviderName }}
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="EnergyRate">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">EnergyRate</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.EnergyRate }}
      </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="UtilityName">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">UtilityName</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.UtilityName }}
      </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="TDSPRatePerMonth">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        Daily Charge
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.TDSPRatePerMonth }}
      </td>
    </ng-container>
    <!-- <ng-container matColumnDef="PUCT">
          <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'"> PUCT </th>
          <td mat-cell *matCellDef="let element" [ngClass]="'w-130'"> {{element.PUCT}} </td>
        </ng-container>  -->
    <!-- <ng-container matColumnDef="TDSPRatePerkWh">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        TDSPRatePerkWh
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.PriorityMoveInFee }}
        {{ element.TDSPRatePerkWh }}
      </td>
    </ng-container> -->
    <ng-container matColumnDef="TDU_Charges_Month">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        TDU_Charges_Month
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.TDU_Charges_Month }}
      </td>
    </ng-container>
    <ng-container matColumnDef="TDU_Charges_Kwh">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        TDU_Charges_kWh
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.TDU_Charges_Kwh }}
      </td>
    </ng-container>
    <ng-container matColumnDef="FiveHundredkWh">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">500kWh</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.FiveHundredkWh }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ThousandkWh">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">1000kWh</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.ThousandkWh }}
      </td>
    </ng-container>
    <ng-container matColumnDef="TwoThousandkWh">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">2000kWh</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.TwoThousandkWh }}
      </td>
    </ng-container>

    <ng-container matColumnDef="EFL">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">EFL</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        <a href="{{ element.EFL }}" target="_blank">Link</a>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="prePaidDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: prePaidDisplayedColumns"></tr>
  </table>
</div>
<mat-paginator
  #prePaidPaginator="matPaginator"
  [pageSizeOptions]="[5, 10, 20]"
  showFirstLastButtons
>
</mat-paginator>
